import { Flex } from "src/components/Flex";
import { useElementSize } from "usehooks-ts";
import { Gauge } from "./Gauge";
import { SentencesList } from "./SentencesList";

export function GaugeMetric(props: {
  value: string;
  data: { name: string; value: 1; color: string }[];
  explanation: string;
}) {
  const value = props.data.findIndex((o) => o.name === props.value) + 0.5;
  const [ref, { width }] = useElementSize();
  return (
    <Flex ref={ref}>
      <SentencesList data={props.explanation} />
      <Flex centered>
        <Gauge width={width * 0.3 || 0} data={props.data} value={value} />
      </Flex>
    </Flex>
  );
}
